import { get } from 'svelte/store';
import { format } from 'svelte-i18n';

import { gen2Request } from '../../services/gen_2_http_reqs';
import { localReq, postReq } from '../../services/http';

import {
	get_gen_2_component_channel_structure,
	is_gen_2,
	is_gen_z,
	real_id,
} from 'src/helpers/interface_helpers';

import type { SettingRequest } from '../../types/requests/settings/setting';

import { toast } from '@Shelly/shelly-design-system';

const _format = get(format);

export const roller_is_calibrated = (device, status, settings) => {
	const isGen2 = is_gen_2(device);
	const isGenZ = is_gen_z(device);
	if (isGenZ) {
		const coverKey = Object.keys(status || {}).find((key) => key.startsWith('cover:'));
		const coverStatus = coverKey ? status?.[coverKey] : undefined;
		return coverStatus?.pos_control !== false && typeof coverStatus?.pos_control !== 'undefined'
			? !!coverStatus.pos_control
			: coverStatus?.current_pos !== undefined && coverStatus?.current_pos !== null;
	}
	return (
		(!isGen2 &&
			device?.category == 'roller' &&
			status?.rollers?.[device?.channel]?.current_pos !== 101 &&
			status?.rollers?.[device?.channel]?.current_pos !== 112 &&
			status?.rollers?.[device?.channel]?.current_pos < 101) ||
		(typeof status?.[`${get_gen_2_component_channel_structure(device)}`]?.pos_control !==
			'undefined' &&
			status?.[`${get_gen_2_component_channel_structure(device)}`]?.pos_control !== false)
	);
};

export const calibrate_cover = async (status, device, local_ip) => {
	const _device_status = status?.[real_id(device.id)]?.[`cover:${device.channel}`];
	const state = _device_status?.state;
	if (state === 'opening' || state === 'closing') {
		return toast.open({
			type: 'danger',
			title:
				_format('cover_before_calibration_error', {
					default: `Cover is reporting that in progress of opening/closing. You need to wait {value}s (based on Cover settings -> Movement time limits).`,
					values: {
						value: _device_status?.move_timeout,
					},
				}) ||
				`Cover is reporting that in progress of opening/closing. You need to
                wait ${
					_device_status?.move_timeout
				}s (based on Cover settings -> Movement time limits).`,
		});
	}

	let res: SettingRequest = await gen2Request(device, 'Cover.Calibrate', {
		id: device.channel,
	});

	if (res.isok) {
		toast.open({
			type: 'success',
			title: _format('calibration_started_scc_toast'),
		});
	} else {
		toast.open({ type: 'danger', title: _format('error_global') });
	}
	return res;
};

export const calibrate_roller = async (device, status, local_ip, devices_status) => {
	let res;

	if (local_ip) {
		res = await localReq(device, `${local_ip}/roller/${device.channel}/calibrate`, 'post', {});
	} else {
		res = await postReq(`/device/relay/roller/settings/calibration`, {
			id: device.id,
			roller_id: device.channel,
			channel: device.channel,
		});
	}

	if (res.isok) {
		toast.open({
			type: 'success',
			title:
				_format('device_is_callibrating_toast') ||
				`Your ${device.category} is calibrating. Settings will appear after calibration is complete.`,
		});
		status.rollers[0].calibrating = true;
		devices_status.update_device_status(status);
	} else {
		toast.open({ type: 'danger', title: _format('error_global') });
	}
};
